import axios from "axios";
import { getCookie } from "../../../../libraries/VueMethods";

const state = {
  extraShippingWithAddItem: {},
  discountCoupen: null,
  changeCartInfo: false,
  hasExtraWeight: false,
  shippings: [],
  cartHasFreeShippingItem: false,
  remaindToFreeShipping:0,
  freeShippingAmount:0
};

const getters = {
  getCartHasFreeShippingItem(state) {
    return state.cartHasFreeShippingItem;
  },
  getShippings(state) {
    return state.shippings;
  },
  getHasExtraWeight(state) {
    return state.hasExtraWeight;
  },
  getChangeCartInfo(state) {
    return state.changeCartInfo;
  },
  getDiscountCoupen(state) {
    return state.discountCoupen;
  },
  getRemaindToFreeShipping(state) {
    return state.remaindToFreeShipping;
  },
  getExtraShippingWithAddItem(state) {
    return state.extraShippingWithAddItem;
  },
  getFreeShippingAmount(state) {
    return state.freeShippingAmount;
  },
};

const mutations = {
  setCartHasFreeShippingItem(state, status) {
    state.cartHasFreeShippingItem = status;
  },
  setShippins(state, list) {
    state.shippings = list;
  },
  setHasExtraWeight(state, status) {
    state.hasExtraWeight = status;
  },
  setChangeCartInfo(state, status) {
    state.changeCartInfo = status;
  },
  setDiscountCoupen(state, discount) {
    state.discountCoupen = discount;
  },
  setExtraShippingWithAddItem(state, data) {
    state.extraShippingWithAddItem[data.address_id] = data.shipping_price;
  },
  setRemaindToFreeShipping(state, data) {
    state.remaindToFreeShipping = data;
  },
  setFreeShippingAmount(state, data) {
    state.freeShippingAmount = data;
  },
};

const actions = {
  getShippingsFromServer({ commit, state }) {
    if (getCookie("Authorization"))
      axios
        .get('customer/cart?show_warning=1&widgets=["shippings", "gateways"]')
        .then((response) => {
          commit("setShippins", response.data.data.widgets.shippings);
          commit(
            "setCartHasFreeShippingItem",
            response.data.data.carts_showcase.has_free_shipping
          );
          commit(
            "setRemaindToFreeShipping",
            response.data.data.carts_showcase.remaindToFreeShipping
          );
          commit(
            "setFreeShippingAmount",
            response.data.data.freeShippingAmount
          );
        });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
